import { FontSizes, FontWeights } from '@fluentui/react';
export var getStyles = function (props) {
    var theme = props.theme, isFooterInBody = props.isFooterInBody, _a = props.hasNavigationHeader, hasNavigationHeader = _a === void 0 ? false : _a;
    return {
        root: [
            {
                color: theme.palette.neutralPrimary,
                margin: (hasNavigationHeader ? '2px' : '20px') + " 0 0 0",
                padding: '0 24px',
                lineHeight: '28px',
                fontSize: FontSizes.size20,
                fontWeight: FontWeights.bold
            },
            isFooterInBody && {
                marginTop: '0px',
                marginBottom: '8px'
            }
        ]
    };
};
//# sourceMappingURL=CoherencePanelHeader.styles.js.map